import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import carousel4 from "../../Assets/carousel-4.jpg";
import carousel5 from "../../Assets/carousel-5.jpg";
import carousel6 from "../../Assets/carousel-6.jpg";
import carousel7 from "../../Assets/carousel-7.jpg";
import carousel8 from "../../Assets/carousel-8.jpg";
import carousel9 from "../../Assets/carousel-9.jpg";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

function Visuels() {
  const scrollContainerRef = useRef(null);
  const scrollContainerRef2 = useRef(null);
  
  const carouselImages = [
    { id: 4, src: carousel4 },
    { id: 5, src: carousel5 },
    { id: 6, src: carousel6 },
    { id: 7, src: carousel7 },
    { id: 8, src: carousel8 },
    { id: 9, src: carousel9 },
  ];

  const carouselImages2 = [
    { id: 10, src: `${process.env.PUBLIC_URL}/images/carousel-10.png` },
    { id: 11, src: `${process.env.PUBLIC_URL}/images/carousel-11.png` },
    { id: 12, src: `${process.env.PUBLIC_URL}/images/carousel-12.png` },
    { id: 13, src: `${process.env.PUBLIC_URL}/images/carousel-13.png` },
    { id: 14, src: `${process.env.PUBLIC_URL}/images/carousel-14.png` },
  ];

  const brandingImages = [
    { id: 1, src: `${process.env.PUBLIC_URL}/images/branding-1.png`, alt: "Ciao Kombucha" },
    { id: 2, src: `${process.env.PUBLIC_URL}/images/branding-2.png`, alt: "Mercedes S63 AMG" },
  ];

  const instaStoryImages = [
    { id: 1, src: `${process.env.PUBLIC_URL}/images/insta-story-1.png`, alt: "Podcast Instagram Story" },
    { id: 2, src: `${process.env.PUBLIC_URL}/images/insta-story-2.png`, alt: "Zara Instagram Story" },
  ];

  const scroll = (direction, containerRef) => {
    if (containerRef.current) {
      const scrollAmount = 370; // 350px width + 20px margin
      containerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Container fluid className="project-section">
      <Particle />
      <div style={{ 
        width: "100%", 
        maxWidth: "1200px", 
        margin: "0 auto",
        padding: "0 20px"
      }}>
        <h1 className="project-heading">
          Mes <strong className="purple">Visuels</strong>
        </h1>
        <p style={{ color: "white" }}>
          Découvrez mes créations visuelles et designs.
        </p>

        {/* Carousels Section */}
        <div style={{ 
          marginTop: "50px", 
          marginBottom: "50px",
          position: "relative",
        }}>
          <h2 className="project-heading" style={{ fontSize: "2em" }}>
            <strong className="purple">Carousels</strong>
          </h2>
          
          {/* Navigation Arrows */}
          <button
            onClick={() => scroll('left', scrollContainerRef)}
            style={{
              position: "absolute",
              left: "-20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              backgroundColor: "rgba(98, 54, 134, 0.8)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 1)";
              e.target.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 0.8)";
              e.target.style.transform = "translateY(-50%) scale(1)";
            }}
          >
            <BsChevronLeft size={24} color="white" />
          </button>
          
          <button
            onClick={() => scroll('right', scrollContainerRef)}
            style={{
              position: "absolute",
              right: "-20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              backgroundColor: "rgba(98, 54, 134, 0.8)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 1)";
              e.target.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 0.8)";
              e.target.style.transform = "translateY(-50%) scale(1)";
            }}
          >
            <BsChevronRight size={24} color="white" />
          </button>

          <div
            ref={scrollContainerRef}
            className="carousel-scroll-container"
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              padding: "20px 0",
              width: "100%",
              position: "relative",
              whiteSpace: "nowrap",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {carouselImages.map((item, index) => (
              <div
                key={item.id}
                style={{
                  display: "inline-block",
                  width: "350px",
                  height: "450px",
                  marginRight: "20px",
                  verticalAlign: "top",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <img
                  src={item.src}
                  alt={`Carousel ${item.id}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Second Carousel Section */}
        <div style={{ 
          marginTop: "80px", 
          marginBottom: "50px",
          position: "relative",
        }}>
          {/* Navigation Arrows for Second Carousel */}
          <button
            onClick={() => scroll('left', scrollContainerRef2)}
            style={{
              position: "absolute",
              left: "-20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              backgroundColor: "rgba(98, 54, 134, 0.8)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 1)";
              e.target.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 0.8)";
              e.target.style.transform = "translateY(-50%) scale(1)";
            }}
          >
            <BsChevronLeft size={24} color="white" />
          </button>
          
          <button
            onClick={() => scroll('right', scrollContainerRef2)}
            style={{
              position: "absolute",
              right: "-20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 10,
              backgroundColor: "rgba(98, 54, 134, 0.8)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 1)";
              e.target.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "rgba(98, 54, 134, 0.8)";
              e.target.style.transform = "translateY(-50%) scale(1)";
            }}
          >
            <BsChevronRight size={24} color="white" />
          </button>

          <div
            ref={scrollContainerRef2}
            className="carousel-scroll-container"
            style={{
              overflowX: "auto",
              overflowY: "hidden",
              padding: "20px 0",
              width: "100%",
              position: "relative",
              whiteSpace: "nowrap",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {carouselImages2.map((item, index) => (
              <div
                key={item.id}
                style={{
                  display: "inline-block",
                  width: "350px",
                  height: "450px",
                  marginRight: "20px",
                  verticalAlign: "top",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <img
                  src={item.src}
                  alt={`Guide Touristique ${item.id}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Branding Section */}
        <div style={{ 
          marginTop: "80px", 
          marginBottom: "50px",
        }}>
          <h2 className="project-heading" style={{ fontSize: "2em", marginBottom: "30px" }}>
            <strong className="purple">Branding</strong>
          </h2>
          
          <div style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}>
            {brandingImages.map((item) => (
              <div
                key={item.id}
                style={{
                  width: "550px",
                  borderRadius: "10px",
                  overflow: "visible",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Instagram Stories Section */}
        <div style={{ 
          marginTop: "80px", 
          marginBottom: "50px",
        }}>
          <h2 className="project-heading" style={{ fontSize: "2em", marginBottom: "30px" }}>
            <strong className="purple">Instagram Stories</strong>
          </h2>
          
          <div style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}>
            {instaStoryImages.map((item) => (
              <div
                key={item.id}
                style={{
                  width: "350px",
                  overflow: "visible",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
}

export default Visuels;
